// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"dc63f888","453":"62fb1eb1"}[chunkId] + ".chunk.js";
};